import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@material-ui/core";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Panel } from "../../../panel";
import { actionsTheme } from "./styles";
import { ThemeProvider } from "@material-ui/core/styles";
import { FunctionButtonResource } from "../../../components/AppActions";
import { WizardMainAndSummary } from ".";
import { useCache } from "@rest-hooks/core";
const panelSettings = {
    summaryHeader: {
        defaultOptions: {
            literal: true
        }
    },
    main: {
        editableOptions: {
            maxWidth: true
        }
    },
    summary: {
        editableOptions: {
            hideForMobile: true
        },
        defaultOptions: {
            literal: true
        }
    },
    actions: {},
    appActions: {}
};
addRegisteredLayout({
    name: "Wizard",
    displayName: "Wizard",
    panels: panelSettings,
    navigationButtonsSummary: true
});
export const Wizard = (props) => {
    const { header, panels } = props;
    const { appActions } = panels;
    const appActionsButtons = useCache(FunctionButtonResource.list(), {});
    const hasActionButtons = (appActionsButtons || []).length > 0;
    return (_jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, container: true, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, md: 4, children: header }), _jsx(Grid, { item: true, xs: 4, container: true, alignItems: "stretch", justifyContent: "flex-end", children: hasActionButtons && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { ...appActions, transparent: true, disableExpansion: true, disableTabs: true, fullWidth: true, justifyContent: "flex-end" }) })) })] }) }), _jsx(WizardMainAndSummary, { ...props })] }));
};
Wizard.displayName = "DployFormWizard";
//# sourceMappingURL=Wizard.js.map